import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GetStudioLogoImageParams {
  studioId: string;
}

interface GetStudioLogoImageResponse {
  studioName: string;
  imageUrl: string;
}

export const getStudioLogoImage = async (params: GetStudioLogoImageParams) => {
  const response = await baseAPI.get<GetStudioLogoImageResponse>(
    `studios/logo-image/${params.studioId}`,
  );
  return response.data;
};

export const getStudioLogoImageOptions = (
  params: GetStudioLogoImageParams,
) => ({
  queryKey: [KEYS.STUDIO_LOGO_IMAGE, params.studioId],
  queryFn: () => getStudioLogoImage(params),
  enabled: !!params.studioId,
  retry: false,
});

export const useGetStudioLogoImage = (params: GetStudioLogoImageParams) => {
  return useQuery(getStudioLogoImageOptions(params));
};
